export default __webpack_public_path__ + "static/media/dados.45ff8b72.jpg";